// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as CopyFDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/copy-f.svg?react';
import { ReactComponent as CopyFSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/copy-f.svg?react';
import { createIcons } from '../../Icon';
export const CopyFIcon = /* @__PURE__ */ createIcons('CopyF', {
    default: CopyFDefault,
    solid: CopyFSolid
});
CopyFIcon.supportedTypes = [
    'default',
    'solid'
];
